import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  createMultipleFrasesConfirmacionPlantelService,
  getFraseConfirmacionPlantelByIdService,
  getFrasesConfirmacionPlantelService,
  toggleFraseConfirmacionPlantelActiveService,
  updateFraseConfirmacionPlantelService,
} from "../../../services/preguntasConfirmacion/phrases-confirmation-plantel/Frasesconfirmacionplantel.service";

export const getFrasesConfirmacionPlantelThunk = createAsyncThunk(
  "frasesConfirmacionPlantel/getAll",
  async (
    { plantelId, page = 1, search = "", talento = "", pregunta = "" } = {},
    { rejectWithValue },
  ) => {
    try {
      return await getFrasesConfirmacionPlantelService(
        plantelId,
        page,
        search,
        talento,
        pregunta,
      );
    } catch (error) {
      if (error.response?.status === 404) {
        return rejectWithValue("Página no válida");
      }
      const message =
        error.response?.data?.detail ||
        error.response?.data?.message ||
        "Error al obtener frases";
      return rejectWithValue(message);
    }
  },
);

export const createMultipleFrasesConfirmacionPlantelThunk = createAsyncThunk(
  "frasesConfirmacionPlantel/createMultiple",
  async (payload, { rejectWithValue }) => {
    try {
      return await createMultipleFrasesConfirmacionPlantelService(payload);
    } catch (error) {
      const message =
        error.response?.data?.detail ||
        error.response?.data?.message ||
        "Error al crear frases";
      return rejectWithValue(message);
    }
  },
);

export const getFraseConfirmacionPlantelByIdThunk = createAsyncThunk(
  "frasesConfirmacionPlantel/getById",
  async (id, { rejectWithValue }) => {
    try {
      return await getFraseConfirmacionPlantelByIdService(id);
    } catch (error) {
      const message =
        error.response?.data?.detail ||
        error.response?.data?.message ||
        "Error al obtener frase";
      return rejectWithValue(message);
    }
  },
);

export const updateFraseConfirmacionPlantelThunk = createAsyncThunk(
  "frasesConfirmacionPlantel/update",
  async ({ id, payload }, { rejectWithValue }) => {
    try {
      return await updateFraseConfirmacionPlantelService(id, payload);
    } catch (error) {
      const message =
        error.response?.data?.detail ||
        error.response?.data?.message ||
        "Error al actualizar frase";
      return rejectWithValue(message);
    }
  },
);

export const toggleFraseConfirmacionPlantelActiveThunk = createAsyncThunk(
  "frasesConfirmacionPlantel/toggleActive",
  async (id, { rejectWithValue }) => {
    try {
      return await toggleFraseConfirmacionPlantelActiveService(id);
    } catch (error) {
      const message =
        error.response?.data?.detail ||
        error.response?.data?.message ||
        "Error al cambiar estado";
      return rejectWithValue(message);
    }
  },
);
